// export enum ActionFlags {
//     Add = 1,
//     Update = 2,
//     Delete = 3,
//     ReActivate = 4,
//     Search = 5
//   }


// export const UserMessages = {
//     PageModeAdd: 'Add',
//     PageModeEdit: 'Edit',
//     PageModeView: 'View',
//     PageModeDelete: 'Delete',
//     SelectRowFromGrid: 'Please select a row from the grid to be edited'
//   };

export const envSettings = {
  headerToolbarYN: false,
  leftPanelYN: false,
  rightPanelYN: false,

  // toggleMainMenu: true,
  // toggleShortCutKeyPanel: false,
  // toggleHelp: false,
  // toggleView: true
  headerSectionIcon: null,
  headerSectionTitle: '',
};


export enum ProviderTypeEnum {
  Doctor = 8001,
  PhysicianExtender = 8002,
  NotApplicable = 8003,
  DoctorOrPhysicianExtender = 8004
}



export enum EncounterProviderType {
  Attn = 1,
  SwapAttn = 2,
  MidlLevel = 3
}

export enum EncounterPatientAction {
  UpdatePatient = 1,
  CreateNewPatient = 2,
}
